import auth from "@/modules/huyu-framework/backend/plugins/auth";
import router, { constantRoutes, dynamicRoutes } from "@/router";
import { getRouters } from "@/modules/huyu-framework/backend/api/menu";
import Layout from "@/layout/index";
import ParentView from "@/modules/huyu-framework/backend/components/ParentView";
import InnerLink from "@/layout/components/InnerLink";
import { ElMessage, ElMessageBox } from "element-plus";
import { clearAllClientCache } from "@/modules/huyu-framework/backend/utils/clientCache";

import { listprojectConfig } from "@/modules/huyu-framework/backend/api/system/projectConfig";

// 匹配 views 里面所有的 .vue 文件 ＋ 各域合仓（src/modules/<域>/frontend/views）的 .vue 文件。
// loadView 取 key 中 "backend/views/"（或本地 "views/"）之后的段与菜单 component 比较。
// vendor-views 通配必须显式加：src/modules/* 目录下只有 .gitignore 占位，
// import.meta.glob 相对路径不经 alias——漏掉它则所有组件包动态菜单 loadView 返回 undefined（2026-10-21 实测构建产物为空对象）。
const modules = {
  ...import.meta.glob("./../../views/**/*.vue"),
  ...import.meta.glob("./../../modules/*/backend/views/**/*.vue"),
  ...import.meta.glob("./../../../vendor-views/@huyu/*/backend/views/**/*.vue"),
};

const usePermissionStore = defineStore("permission", {
  state: () => ({
    routes: [],
    addRoutes: [],
    defaultRoutes: [],
    topbarRouters: [],
    sidebarRouters: [],
  }),
  actions: {
    setRoutes(routes) {
      this.addRoutes = routes;
      this.routes = constantRoutes.concat(routes);
    },
    setDefaultRoutes(routes) {
      this.defaultRoutes = constantRoutes.concat(routes);
    },
    setTopbarRoutes(routes) {
      this.topbarRouters = routes;
    },
    setSidebarRouters(routes) {
      this.sidebarRouters = routes;
    },
    generateRoutes(res) {
      // if (res == undefined) {
      //   let projectId = localStorage.getItem("projectId");
      //     res = {
      //       projectId: projectId,
      //     };
      // }
      let projectId = localStorage.getItem("projectId");
      let moduleId = localStorage.getItem("moduleId");
      let roleId = localStorage.getItem("roleId");
      // if (moduleId != undefined) {
      //   res = {
      //     moduleId: moduleId,
      //   };
      // } else
      if (projectId != undefined) {
        res = {
          projectId: projectId,
        };

        if (roleId != undefined && roleId != -1) {
          res.roleId = roleId;
          //
        }
      }
      // localStorage.removeItem("roleId");
      return new Promise((resolve) => {
        // 向后端请求路由数据
        getRouters(res).then(async (res) => {
          if (res.data.length == 0) {
            ElMessageBox.alert(
              "当前登录账号无路由数据，请切换账号登录",
              "提示",
              {
                // if you want to disable its autofocus
                // autofocus: false,
                confirmButtonText: "确定",
                callback: (action) => {
                  clearAllClientCache();
                  location.href = "/login";
                },
              }
            );

            return;
          }
          // return

          let projectId = localStorage.getItem("projectId");
          let cofig = {};
          // 只有持有 system:projectConfig:list 的账号才发这个请求。
          // 演示/只读账号没有该权限，发出去必被后端拒（Access Denied），
          // 前端本来也只会走 catch，属于纯噪音。
          if (auth.hasPermi("system:projectConfig:list")) {
            try {
              cofig = await listprojectConfig({
                projectId: projectId,
                configKey: "LYAXMMKFZ",
              });
            } catch (e) {
              console.log("项目配置", e);
            }
          }


          console.log("项目配置", cofig);
          let data = null;

          if (cofig.rows && cofig.rows[0]?.configValue == "true") {
            data = res.data;
          } else {
            let list = await useReduceSort(res.data, "moduleId");



            let nu = Object.keys(list);
            if (nu.length != 0) {
              let moduleId = localStorage.getItem("moduleId");
              if (moduleId) {
              } else {
                localStorage.setItem("moduleId", list[nu[0]][0].moduleId);
              }
            }

            data = handleRouter(list);


          }

          // let data = handleRouter(list);



          localStorage.setItem("routerModuleList", JSON.stringify(data));

          // let s = route.children.find((ie) => {
          //   if (ie.path == '/') return true
          // })
          // if(s!=undefined) return
          // return;
          const sdata = JSON.parse(JSON.stringify(data));
          const rdata = JSON.parse(JSON.stringify(data));

          const defaultData = JSON.parse(JSON.stringify(data));
          const sidebarRoutes = filterAsyncRouter(sdata);
          const rewriteRoutes = filterAsyncRouter(rdata, false, true);
          const defaultRoutes = filterAsyncRouter(defaultData);
          const asyncRoutes = filterDynamicRoutes(dynamicRoutes);

          asyncRoutes.forEach((route) => {

            router.addRoute(route);
          });
          this.setRoutes(rewriteRoutes);
          this.setSidebarRouters(constantRoutes.concat(sidebarRoutes));
          this.setDefaultRoutes(sidebarRoutes);
          this.setTopbarRoutes(defaultRoutes);
          resolve(rewriteRoutes);
        });
      });
    },
  },
});

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  return asyncRouterMap.filter((route) => {
    if (type && route.children) {
      route.children = filterChildren(route.children);
    }
    if (route.component) {
      // Layout ParentView 组件特殊处理
      if (route.component === "Layout") {
        route.component = Layout;
      } else if (route.component === "ParentView") {
        route.component = ParentView;
      } else if (route.component === "InnerLink") {
        route.component = InnerLink;
      } else {
        route.adrees = route.component;
        route.component = loadView(route.component);
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type);
    } else {
      delete route["children"];
      delete route["redirect"];
    }
    return true;
  });
}

function filterChildren(childrenMap, lastRouter = false) {
  var children = [];
  childrenMap.forEach((el, index) => {
    if (el.children && el.children.length) {
      if (el.component === "ParentView" && !lastRouter) {
        el.children.forEach((c) => {
          c.path = el.path + "/" + c.path;
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c));
            return;
          }
          children.push(c);
        });
        return;
      }
    }
    if (lastRouter) {
      el.path = lastRouter.path + "/" + el.path;
      if (el.children && el.children.length) {
        children = children.concat(filterChildren(el.children, el));
        return;
      }
    }
    children = children.concat(el);
  });
  return children;
}

// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes(routes) {
  const res = [];
  routes.forEach((route) => {
    if (route.permissions) {
      if (auth.hasPermiOr(route.permissions)) {
        res.push(route);
      }
    } else if (route.roles) {
      if (auth.hasRoleOr(route.roles)) {
        res.push(route);
      }
    }
  });
  return res;
}

export const loadView = (view) => {
  let res;
  for (const path in modules) {
    // vendor key（vendor-views/@huyu/x-views/backend/views/a.vue）含多段 "views/"，
    // 必须优先按 "backend/views/" 切；本地 key（views/a.vue）退回按 "views/" 切。
    const seg = path.includes("backend/views/")
      ? path.split("backend/views/")[1]
      : path.split("views/")[1];
    const dir = seg.split(".vue")[0];
    if (dir === view) {
      res = () => modules[path]();
    }
  }
  return res;
};

export default usePermissionStore;

//使用Reduce分类
async function useReduceSort(value, installPlace) {
  return new Promise((resolve, reject) => {
    const grouped = value.reduce((result, currentValue) => {
      const key = currentValue[installPlace];
      // 如果 key 是 undefined，则跳过当前项
      if (key === undefined) {
        return result;
      }

      // console.log(result, currentValue, key);
      //如果没有就新建一个
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push(currentValue);
      // console.log(result);
      return result;
    }, {});

    resolve(grouped);
  });
}
// /
function handleRouter(obj) {
  let moduleIdList = localStorage.getItem("modules");
  moduleIdList = JSON.parse(moduleIdList);

  // 🚨 顺序与父子结构（2026-11-05 线上实测后重写，勿回退成 list.unshift）：
  // 1) 原写法 `list.unshift(...a)` 把每个非通用模块逐个插到数组最前，N 个模块就反转 N-1 次，
  //    项目 9 的「一卡通业务(1)/一卡通设备(2)/一卡通财务(3)」实际渲染成「财务→设备→业务」倒序。
  // 2) 顺序的唯一真源是后端 modules 数组：`SysUserMapper.selectProjectModules`
  //    `ORDER BY pm.order_num ASC`（project_module_list.order_num）。所以这里一律 push，
  //    **不要按 bindType 分段**——分段会把 bindType='其他' 的 9018 预约通用(98) 顶到
  //    数据中心(14)/视频中心(15) 前面，覆盖 DB 里的顺序。
  // 3) 后端 buildMenus 对「0 级 C 型菜单」产出的是 meta=null 的 Layout 空壳
  //    （SysMenuServiceImpl.setMeta(null)，path='/' + 唯一子路由）。非通用模块不做模块名包裹，
  //    空壳会原样进侧边栏 → 一级标题渲染成 undefined（项目 9：门禁管理 1539 / 首页 1762）。
  //    这里把空壳拆开，用唯一子路由顶替，并补绝对 path。
  let list = [];
  moduleIdList = Array.isArray(moduleIdList) ? moduleIdList : [];
  moduleIdList.forEach((item) => {
    let a = obj[item.moduleId];
    //获取m

    if (a == undefined) return;
    if (!Array.isArray(a)) a = [a];

    let aList = [];
    if (item.bindType != "通用模块") {
      a.forEach((e) => {
        const isBlankShell =
          (!e.meta || !e.meta.title) &&
          Array.isArray(e.children) &&
          e.children.length === 1;
        if (isBlankShell) {
          const only = e.children[0] || {};
          const rawPath = String(only.path || e.path || "").replace(/^\//, "");
          list.push({
            ...only,
            path: "/" + (rawPath || "m" + (only.menuId || e.menuId || item.moduleId)),
            meta: {
              ...(only.meta || {}),
              title: (only.meta && only.meta.title) || e.name || item.moduleName,
            },
          });
        } else {
          list.push(e);
        }
      });
    } else {
      a.map((e) => {
        if (e.alwaysShow == true) {
          e.component = "ParentView";
          e.path = e.path.replace("/", "");
          aList.push(e);
        } else {
          // 检查 e.children 是否存在且是数组
          if (Array.isArray(e.children)) {
            aList.push(...e.children);
          } else {
            // 如果 e.children 不存在，直接 push e
            aList.push(e);
          }
        }
      });

      if (aList.length == 1) {
        // 🚨 单子项展平：只有当这唯一子项本身是个「目录」时才上提它的 children。
        // 若它是叶子（外链/单页，没有 children），必须把叶子自己包成唯一子项，
        // 否则 children = undefined → 侧边栏出现点不开的空组。
        // 实例：模块 159「运维监控」全部内容只有 6391「流量监控」一条外链，
        // 24 个绑定项目点开都是空组（2026-11-05 线上实测）。
        list.push({
          children: Array.isArray(aList[0].children) ? aList[0].children : [aList[0]],
          component: "Layout",
          hidden: false,
          path: "/" + item.moduleKey,
          orderNum: item.orderNum,
          meta: {
            icon: item.moduleIcon,
            noCache: false,
            title: item.moduleName,
          },
        });
      } else {
        list.push({
          children: aList,
          component: "Layout",
          hidden: false,
          path: "/" + item.moduleKey,
          orderNum: item.orderNum,
          meta: {
            icon: item.moduleIcon,
            noCache: false,
            title: item.moduleName,
          },
        });
      }

    }

  });

  list = expandSingleChild(list);

  return list;
}

function expandSingleChild(list) {
  if (!Array.isArray(list)) {
    return list;
  }




  list.map((item) => {
    if (!item.children || item.children.length !== 1) {
      return item;
    }

    const onlyChild = item.children[0];

    if (onlyChild.children) {
      const expanded = expandSingleChild([onlyChild]);
      if (expanded.length === 1 && expanded[0].children) {
        item.children = expanded[0].children;
        item.path = "/" + (expanded[0].path || "");
        item.component = "Layout";
        return expandSingleChild([item]);
      }
      item.children = expanded;
    }

    if (!item.path) {
      item.path = "/";
    }

    return item;
  });


  return list;
}
